module.exports = "/src/views/games/other/images/roles/mafia.png";